import { Box, Typography } from "@mui/material";
import { getDirectDebitSentence, toToman } from "../../utils/Utils";
import StartDirectDebit from "../../assets/images/start-direct-debit.svg";
import moment from "moment-jalaali";
import { useNavigate } from "react-router-dom";

function ActiveDirectDebitBanner({ sx = [], ...props }) {
  const { subscription } = props;
  const navigate = useNavigate();
  return (
    <Box
      onClick={() => {
        navigate("/app/direct-debit");
      }}
      sx={{
        width: "100%",
        p: "12px",
        borderRadius: "12px",
        boxShadow: (theme) => theme.shadows[3],
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-end",
        }}
      >
        <img src={StartDirectDebit} width={112} height={68} />
        <Box
          sx={{
            ml: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography variant="h6" color="primary.main">
              پس‌انداز خودکار
            </Typography>
            <Typography variant="subtitle1" color="grey.2">
              {getDirectDebitSentence(subscription)}
            </Typography>
          </Box>
          <Box mt={1}>
            <Typography variant="subtitle1" color="grey.4">
              آخرین پس انداز
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {subscription?.lastTransaction ? (
                <>
                  <Typography variant="subtitle1" color="grey.3">
                    {`${toToman(
                      subscription.lastTransaction?.amount || 0
                    )} تومان`}
                  </Typography>
                  <Typography ml={2} variant="subtitle1" color="grey.3">
                    {moment(subscription.lastTransaction?.requestTime).format(
                      "jYYYY/jMM/jDD"
                    )}
                  </Typography>
                </>
              ) : (
                <Typography fontSize={12} color="grey.3">
                  پس‌انداز خودکار موفق نداشته‌اید
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default ActiveDirectDebitBanner;
